import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

export interface MedicationAdministrationFiltersState {
  practitioner: string;
  status: string[];
  "triage-type": string[];
  location: string[];
}

const initialState: MedicationAdministrationFiltersState = {
  practitioner: "",
  status: [],
  "triage-type": [],
  location: [],
};

const slice = createSlice({
  name: "medicationAdministrationFilters",
  initialState,
  reducers: {
    setMedicationAdministrationFilters(
      state: MedicationAdministrationFiltersState,
      action: PayloadAction<Partial<MedicationAdministrationFiltersState>>,
    ): void {
      Object.assign(state, action.payload);
    },
    updateMedicationAdministrationFilter(
      state: MedicationAdministrationFiltersState,
      action: PayloadAction<{ key: string; value: any }>,
    ): void {
      const { key, value } = action.payload;
      (state as any)[key] = value;
    },
    resetMedicationAdministrationFilters(
      state: MedicationAdministrationFiltersState,
    ): void {
      Object.assign(state, initialState);
    },
  },
});

export const {
  setMedicationAdministrationFilters,
  updateMedicationAdministrationFilter,
  resetMedicationAdministrationFilters,
} = slice.actions;
export const { reducer } = slice;

export default slice;
